/**
 * La garde de la relecture du compte au retour sur un onglet de l'élève (l'accueil, Activités).
 *
 * Revenir sur l'un des deux onglets relit le compte (`getUser`, la réponse la plus lourde de l'API),
 * pour les données restées d'une veille. Un aller-retour entre les deux en envoyait deux de suite.
 * La règle (Wajih, 18/10) : une lecture en vol, ou partie il y a moins de `ACCOUNT_REREAD_FRESH_MS`,
 * suffit — quel que soit celui qui l'a lancée (la coquille au montage ou au retour au premier plan,
 * un onglet, « GO ! »).
 *
 * Elle ne vaut QUE pour le retour sur un onglet. Le premier affichage (la coquille lit le compte à son
 * montage) et le retour de l'app au premier plan (`useLiveAccessRefresh` de la coquille) ne passent
 * pas par elle : ils relisent toujours. La flèche ou « Réessayer » non plus : un geste de l'élève lit.
 */

/** Une lecture du compte partie il y a moins de 30 s vaut pour un retour sur l'onglet. */
export const ACCOUNT_REREAD_FRESH_MS = 30 * 1000

export function accountRereadDue(args: { inFlight: boolean; lastReadAt: number | null; now: number }): boolean {
    const { inFlight, lastReadAt, now } = args
    if (inFlight) return false
    return lastReadAt == null || now - lastReadAt >= ACCOUNT_REREAD_FRESH_MS
}

/**
 * Quand la dernière lecture du compte est partie, vue par les onglets : un seul relevé pour les deux,
 * comme la règle le veut (« une lecture récente suffit », d'où qu'elle vienne). Il vit le temps de
 * l'app, comme le store ; il ne dit que l'heure, jamais à qui est le compte.
 */
let lastAccountReadAt: number | null = null

export function noteAccountRead(at: number): void {
    lastAccountReadAt = at
}

export function lastAccountRead(): number | null {
    return lastAccountReadAt
}
